import { AliasService, IAliasService } from './alias-service';
import {
  NewApiAliasForDataField,
  NewApiAliasForMetricCategoryId,
  NewApiAliasForMetricGroupId,
} from './api-interfaces';

export class CachedAliasService implements IAliasService {
  private aliasService: AliasService;

  constructor(underlying: AliasService) {
    this.aliasService = underlying;
  }

  public getDeps = () => [...this.aliasService.getDeps()];

  public async setAliasForDataField(
    alias: NewApiAliasForDataField
  ): Promise<void> {
    return this.aliasService.setAliasForDataField(alias);
  }

  public async setAliasForMetricGroupId(
    alias: NewApiAliasForMetricGroupId
  ): Promise<void> {
    return this.aliasService.setAliasForMetricGroupId(alias);
  }

  public async setAliasForMetricCategoryId(
    alias: NewApiAliasForMetricCategoryId
  ): Promise<void> {
    return this.aliasService.setAliasForMetricCategoryId(alias);
  }

  public async deleteAliasForDataField(
    alias: NewApiAliasForDataField
  ): Promise<void> {
    return this.aliasService.deleteAliasForDataField(alias);
  }

  public async deleteAliasForMetricGroupId(
    alias: NewApiAliasForMetricGroupId
  ): Promise<void> {
    return this.aliasService.deleteAliasForMetricGroupId(alias);
  }

  public async deleteAliasForMetricCategoryId(
    alias: NewApiAliasForMetricCategoryId
  ): Promise<void> {
    return this.aliasService.deleteAliasForMetricCategoryId(alias);
  }
}
